import { render } from "./BlckAlgoan.vue?vue&type=template&id=23c52ef4&scoped=true"
import script from "./BlckAlgoan.vue?vue&type=script&lang=js"
export * from "./BlckAlgoan.vue?vue&type=script&lang=js"

import "./BlckAlgoan.vue?vue&type=style&index=0&id=23c52ef4&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c52ef4"]])

export default __exports__